"use strict";

var _Icon;
import { c as _c } from "react/compiler-runtime";
import { MenuHamburgerIcon } from '@autoguru/icons';
import { Box, Icon } from '@autoguru/overdrive';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const windowAsideToggleFnName = '__open_ag__sidenav';
const AppSideHandle = () => {
  const $ = _c(1);
  const openAside = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Box, {
      is: "button",
      role: "button",
      "aria-label": "Aside menu button",
      display: "flex",
      onClick: openAside,
      children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        size: "large",
        icon: MenuHamburgerIcon
      }))
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AppSideHandle;
function _temp() {
  if (typeof window[windowAsideToggleFnName] === "function") {
    window[windowAsideToggleFnName]();
  }
}